import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export interface ExportTableData {
  [key: string]: any;
}

export function exportToExcelMultipleSheets(
  datasets: { sheetName: string; data: ExportTableData[]; columns: string[],headers:string[] }[],
  filename: string
): void {
  const workbook: XLSX.WorkBook = XLSX.utils.book_new();

  datasets.forEach(({ sheetName, data, columns,headers }) => {
    const worksheetData = [headers, ...data.map(item => columns.map(col => item[col]))];
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(worksheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  });

  const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(blob, `${filename}.xlsx`);
}
